import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

interface Ctx {
  open: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const AddQuestCtx = createContext<Ctx | null>(null);

export function AddQuestProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);
  return (
    <AddQuestCtx.Provider value={{ open, openModal, closeModal }}>
      {children}
    </AddQuestCtx.Provider>
  );
}

export function useAddQuest(): Ctx {
  const v = useContext(AddQuestCtx);
  if (!v) throw new Error('useAddQuest must be used inside AddQuestProvider');
  return v;
}
